<mat-dialog-content>
    <div class="hypo-dialog-header">
        <div class="hypo-dialog-title">
            <mat-icon>check_circle</mat-icon>
            Kontaktujte hypotečního specialistu
        </div>
    </div>

    <div class="hypo-dialog-content">
        <div class="confirm-body">
            <div class="offer-container">
                <p>Začínáme pracovat na Vaší žádosti o hypotéku.</p>
                <p>
                    <span style="color: #ff3f4e">Důležité</span>: Nyní, prosím,
                    <strong>kontaktujte hypotečního specialistu</strong> na telefonu
                    <a [href]="'tel:' + owner.phone">{{ owner.phone }}</a> ({{ owner.firstName }}&nbsp;{{
                        owner.lastName
                    }}) pro dokončení procesu.
                </p>
                <p>Specialista s Vámi provede závěrečnou kontrolu a následně vše odešle do banky na posouzení.</p>
            </div>

            <app-contact-specialist [owner]="owner"></app-contact-specialist>
        </div>

        <div class="hypo-dialog-footer mb-4 flex flex-row items-center justify-center">
            <button
                (click)="matDialogRef.close()"
                class="btn orange documents-confirm-dialog-button-rozumim"
                [attr.data-testid]="'documents-confirm-dialog-button-agree'"
                mat-button
                type="button">
                Rozumím
            </button>
        </div>
    </div>
</mat-dialog-content>
